module.exports = __webpack_public_path__ + "img/robot-empty.1854ba47.svg";